import React from 'react';
import { Label, Popup } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import useCountComments from '@api/comment/hooks/useCountComments';
import styles from './CommentsCount.module.scss';

type Props = {
  uploadId: number;
};

function CommentsCount({ uploadId }: Props) {
  const { t } = useTranslation();
  const { commentsCount } = useCountComments(uploadId, { enabled: true });
  if (!commentsCount || commentsCount < 1) {
    return null;
  }
  return (
    <Popup
      content={t('upload.comment.count', { commentsCount })}
      trigger={
        <Label circular color="red" size="tiny" floating className={styles.countLabel}>
          {commentsCount}
        </Label>
      }
    />
  );
}
export default CommentsCount;
